import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MenuTitle from '../../atoms/menu/MenuTitle';
import Menu from '../../atoms/menu/Menu';
import Flex from '../../atoms/Flex';
import Badge from '../../atoms/Badge';
const MenuGroup = ({ title, badgeText, children, }) => {
    return (_jsxs(Menu, { children: [_jsxs(Flex, { justifyContent: "space-between", children: [title && _jsx(MenuTitle, { children: title }), badgeText && _jsx(Badge, { children: badgeText })] }), children] }));
};
export default MenuGroup;
